export const orderSection = (sections: TestSection[]) =>
  sections.sort((a: TestSection, b: TestSection) =>
    parseInt(a.section.sequence, 10) > parseInt(b.section.sequence, 10) ? 1 : -1
  );
